// extracted by mini-css-extract-plugin
export var wrapper = "layout-module--wrapper--2_x6O";
export var layout = "layout-module--layout--22H26";
export var footerContent = "layout-module--footerContent--2SXOh";
export var hello = "layout-module--hello--1Yfz_";
export var projects = "layout-module--projects--WiXww";